import { getStyleSheetClasses } from '../../../services/jss';

export default getStyleSheetClasses({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  report: {

  },
  reportBreakdownTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& tbody tr:nth-child(2n+1) td': {
      backgroundColor: 'rgb(229, 231, 249)',
      '-webkit-print-color-adjust': 'exact'
    },
    '& em': {
      fontSize: 'smaller'
    }
  },
  reportSummaryTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& tbody tr:nth-child(2n+1) td': {
      backgroundColor: 'rgb(229, 231, 249)',
      '-webkit-print-color-adjust': 'exact'
    },
    '& em': {
      fontSize: 'smaller'
    }
  },
  reportFooterActions: {
    margin: '30px 0'
  }
});



// WEBPACK FOOTER //
// ./src/views/report/styles/index.js